import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import { CopyProductsRequest, CopyProductsResponse } from 'src/types/favorite';
import axiosInstance from 'src/utils/axios';

export async function copyFavoriteProducts(
  request: CopyProductsRequest
): Promise<CopyProductsResponse> {
  const res = await axiosInstance.post<CopyProductsResponse>(api.copyFavoriteProducts, request);
  return res.data;
}

const useCopyFavoriteProductsMutation = ({
  onSuccess,
  onError,
}: {
  onSuccess?: (data: CopyProductsResponse) => void;
  onError?: (error: Error) => void;
} = {}) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationKey: queryKeys.favorite.copyFavoriteProducts(),
    mutationFn: copyFavoriteProducts,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.favorite.root });
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error as Error);
    },
  });

  return mutation;
};

export default useCopyFavoriteProductsMutation;
